const chrome = {
	name: 'Google Chrome',
	icon: 'fa-chrome',
	url: 'https://www.google.com/chrome/'
};

const firefox = {
	name: 'Mozilla Firefox',
	icon: 'fa-firefox',
	url: 'https://www.mozilla.org/en-US/firefox/new/'
};

const edge = {
	name: 'Microsoft Edge',
	icon: 'fa-edge',
	url: 'https://www.microsoft.com/en-ca/software-download/windows10'
};

const getBrowserSupportList = browser => {
	const browserList = [chrome, firefox];

	if (browser.osname === 'Windows' && browser.osversion === '10') {
		browserList.push(edge);
	}

	return browserList;
};

class BrowserLinksController {
	constructor(browser, $window) {
		'ngInject';

		this.$window = $window;
		this.currentBrowser = browser;
		if (!browser.supported) this.newBrowsers = getBrowserSupportList(browser);
	}

}

export default {
	template: require('./browser-links.template.html'),
	controller: BrowserLinksController,
	bindings: {},
	controllerAs: 'vm'
};
